"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledComboboxLoadingState = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ComboboxLoadingStateMixin = require("../../mixins/components/ComboboxLoadingStateMixin");
var StyledComboboxLoadingState = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledComboboxLoadingState",
  componentId: "c11n-8-107-0__sc-1yxjp86-0"
})(["", ""], _ComboboxLoadingStateMixin.ComboboxLoadingStateMixin);
exports.StyledComboboxLoadingState = StyledComboboxLoadingState;